module.exports = __webpack_public_path__ + "img/redScreen.412021f3.png";